import React, { useMemo } from 'react';
import { Col, Row } from 'react-bootstrap';
import { Cell } from 'react-table';
import TableCommon from 'Components/Common/Table/TableCommon';

import {
  renderCampaignInformation,
  renderId,
  renderJanCode,
  renderPrice,
  renderProductsCode,
  renderSaleId,
  renderSalesChannel,
  renderStartDate,
  renderUpdate,
  renderVariation,
} from 'Components/Page/ListProducts/ColumnsTableProducts';
import { SortMethod } from 'Components/Common/Table/table';
interface IListProducts {
  [key: string]: any;
}

interface ITableProducts {
  data: any;
  onSort?: (sortingState: SortMethod[]) => void;
}

export default function TableListProducts({ data, onSort }: ITableProducts): JSX.Element {
  const columns = useMemo(
    () => [
      {
        Header: '',
        accessor: 'empty',
        className: 'pe-none',
        columns: [
          {
            Header: '商品No.',
            accessor: 'id',
            width: '80',
            className: 'd-flex align-items-center justify-content-center',
            Cell: ({ row }: Cell<IListProducts>) => {
              return renderId(row);
            },
          },
          {
            Header: 'キャンペーン商品名称',
            width: '300',
            accessor: 'type',
            className: 'align-items-center justify-content-center',
            Cell: ({ row }: Cell<IListProducts>) => {
              return renderSalesChannel(row);
            },
          },
          {
            Header: 'キャンペーン情報',
            width: '300',
            className: 'align-items-center justify-content-center',
            Cell: ({ row }: Cell<IListProducts>) => {
              return renderCampaignInformation(row);
            },
          },
          {
            Header: '販売用ID',
            width: '300',
            className: ' align-items-center justify-content-center',
            Cell: ({ row }: Cell<IListProducts>) => {
              return renderSaleId(row);
            },
          },
          {
            Header: 'バリエーション',
            width: '160',
            className: 'align-items-center justify-content-center',
            Cell: ({ row }: Cell<IListProducts>) => {
              return renderVariation(row);
            },
          },
          {
            Header: 'DL開始日時',
            width: '140',
            className: 'align-items-center justify-content-center',
            Cell: ({ row }: Cell<IListProducts>) => {
              return renderStartDate(row);
            },
          },
          {
            Header: '販売価格',
            width: '80',
            className: 'align-items-center justify-content-center',
            Cell: ({ row }: Cell<IListProducts>) => {
              return renderPrice(row);
            },
          },
          {
            Header: '品番',
            width: '120',
            className: 'align-items-center justify-content-center',
            Cell: ({ row }: Cell<IListProducts>) => {
              return renderProductsCode(row);
            },
          },
          {
            Header: 'JANコード',
            width: '130',
            className: 'align-items-center justify-content-center',
            Cell: ({ row }: Cell<IListProducts>) => {
              return renderJanCode(row);
            },
          },
          {
            Header: '登録更新日',
            width: '130',
            accessor: 'updatedAt',
            className: 'd-flex align-items-center justify-content-center',
            Cell: ({ row }: Cell<IListProducts>) => {
              return renderUpdate(row);
            },
          },
        ],
      },
    ],
    [],
  );

  return (
    <Row className="">
      {data.length > 0 ? (
        <div className="table-list-products">
          <Row>
            <Col md={12} className="d-flex justify-content-center">
              <TableCommon
                heightBody="calc(100vh - 240px)"
                data={data}
                columns={columns}
                getCellProps={() => {
                  return {
                    className: 'p-0',
                  };
                }}
                getRowProps={(row) => {
                  return {
                    className: `${row?.original?.type === 0 && 'master-record-row'}`,
                  };
                }}
                manualSortBy
                onSort={onSort}
              />
            </Col>
          </Row>
        </div>
      ) : (
        <div className="vh-100-final d-flex align-items-center justify-content-center">
          検索結果がありません。
        </div>
      )}
    </Row>
  );
}
